import { render, staticRenderFns } from "./ChangeFavoriteLanguage.vue?vue&type=template&id=b607fb24&scoped=true"
import script from "./ChangeFavoriteLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeFavoriteLanguage.vue?vue&type=script&lang=js"
import style0 from "./ChangeFavoriteLanguage.vue?vue&type=style&index=0&id=b607fb24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b607fb24",
  null
  
)

export default component.exports